var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderNetworking1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.34403 6.5C5.22689 6.5 5.11208 6.5079 4.99999 6.52314V4C4.99999 2.89543 5.89542 2 6.99999 2H9.7821C10.3063 2 10.8095 2.2058 11.1835 2.5731L12.1165 3.4894C12.4905 3.8567 12.9937 4.0625 13.5179 4.0625H17C18.1046 4.0625 19 4.95793 19 6.0625V6.52314C18.8879 6.5079 18.7731 6.5 18.656 6.5H5.34403Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34402 8C4.67416 8 4.19371 8.64574 4.3862 9.28735L5.9724 14.5747C6.22619 15.4207 7.00484 16 7.88805 16H11.25V18.1454C10.7487 18.3483 10.3483 18.7486 10.1454 19.25H2C1.58579 19.25 1.25 19.5858 1.25 20C1.25 20.4142 1.58579 20.75 2 20.75H10.1454C10.4421 21.483 11.1607 22 12 22C12.8393 22 13.5579 21.483 13.8546 20.75H22C22.4142 20.75 22.75 20.4142 22.75 20C22.75 19.5858 22.4142 19.25 22 19.25H13.8546C13.6517 18.7486 13.2513 18.3483 12.75 18.1454V16H16.1119C16.9951 16 17.7738 15.4207 18.0276 14.5747L19.6138 9.28735C19.8063 8.64574 19.3258 8 18.656 8H5.34402Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderNetworking1);
export default __webpack_public_path__ + "static/media/folder-networking-1.1e1392dd3dd2fecfeab9b74d4733af14.svg";
export { ForwardRef as ReactComponent };